<div class="valid-reference-excluded-toggle">
  <mat-checkbox color="primary" (change)="toggleExcludeValidReferences()" [checked]="excludeValidReferences">
    Exclude valid references
  </mat-checkbox>
</div>
<table>
  <thead>
    <tr>
      <th class="type-column">Type</th>
      <th class="target-content-column">Target</th>
      <th class="valid-column">Valid</th>
      <th class="inline-reference-location-column">Inline reference locations</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let row of expandedRows">
      <tr [class.invalid-reference]="!row.valid">
        <td>{{ row.targetType }}</td>
        <td>
          <a [href]="row.targetContent.targetUrl" target="_blank">{{ row.targetContent.displayText }}</a>
        </td>
        <td>
          <div class="icon {{ row.valid ? 'valid-reference' : '' }}">
            <mat-icon>{{ row.valid ? 'check_circle' : 'error' }}</mat-icon>
            {{ row.valid ? 'Yes' : 'No' }}
          </div>
        </td>
        <td>
          <ng-container *ngFor="let inlineRef of row.inlineReferences; let inlineRefIndex = index">
            <a [href]="inlineRef.targetUrl" target="_blank">{{ inlineRef.displayText }}</a
            >{{ inlineRefIndex === row.inlineReferences.length - 1 ? '' : ', ' }}
          </ng-container>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="expandedRows.length === 0">
      <td colspan="4">No {{ excludeValidReferences ? 'invalid' : '' }} references</td>
    </tr>
  </tbody>
</table>
